import * as React from 'react';

export type SocialPostPreviewSkin = 'facebook' | 'instagram';
export type SocialPostPreviewProps = {
  /** Contains the post’s profile name (a username in Facebook or Instagram) */
  profileName?: React.ReactNode;
  /** Contains a URL link to the post’s profile picture */
  profileImageSrc?: string;
  /** Controls the appearance and layout of the component */
  skin?: SocialPostPreviewSkin;
  /** Adds textual post content */
  caption?: React.ReactNode;
  /** Adds visual post content (most commonly, <Image/> is added as a child item) */
  media?: React.ReactNode;
  /** Applies a CSS class to the component’s root element */
  className?: string;
  /** Applies a data-hook HTML attribute to be used in the tests */
  dataHook?: string;
};
